import { useEffect, useRef, useState } from 'react';

/**
 * Dispara quando o elemento entra (ou está perto) da viewport — útil para lazy load de mídia.
 */
export function useInView(rootMargin = '240px'): [React.RefObject<HTMLDivElement>, boolean] {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (inView) return;

    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, [inView, rootMargin]);

  return [ref, inView];
}
